import { render, staticRenderFns } from "./send-reset-link-modal.vue?vue&type=template&id=e22c17c6&"
import script from "./send-reset-link-modal.vue?vue&type=script&lang=js&"
export * from "./send-reset-link-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports